export default {
  Schema: {
    List: "SchemaList",
    Detail: "SchemaDetail",
  },
  Result: {
    List: "ResultList",
    Detail: "ResultDetail",
  },
  Schedule: {
    List: "ScheduleList",
    OptionList: "ScheduleOptionList",
    Detail: "ScheduleDetail",
    ParticipantList: "ScheduleParticipantList",
    ParticipantOptionList: "ScheduleParticipantOptionList",
    TimeScheduleList: "ScheduleTimeScheduleList",
  },
  SurveyLink: {
    List: "SurveyLinkList",
  },
  TakeSurvey: {
    Detail: "TakeSurveyDetail",
    SchemaQuestionList: "TakeSurveySchemaQuestionList",
  },
  Report: {
    Summary: "ReportSummary",
    CountByQuestion: "ReportCountByQuestion",
    ResultList: "ReportResultList",
  },
  Template: {
    OptionList: "TemplateOptionList",
  },
  MasterData: {
    LabelList: "LabelMasterDataList",
  },
} as const;
